import axios from "axios";
import { toApiAbsoluteUrl } from "../components/Document/DocumentUtils";

/**
 * A document shown inside the Salesforce intake console (dms_backend
 * documents/views/salesforce_viewing.py). The pass in the address is the
 * whole credential: plain axios, no cookies, no interceptors — a 410 here
 * must never trigger the app's sign-in redirect.
 */
export const fetchEmbeddedDocument = async (token) => {
  const response = await axios.get(
    toApiAbsoluteUrl(`/api/documents/embed/${encodeURIComponent(token)}/`),
    { validateStatus: () => true },
  );
  if (response.status === 200) return response.data;
  const error = new Error(
    response.data?.error
      || (response.status === 410
        ? "This viewing link has expired."
        : response.status === 404
          ? "This document is no longer available."
          : "The document could not be opened."),
  );
  error.status = response.status;
  throw error;
};

/** The viewer's resolver for an embedded document: what the pass returned. */
export const resolverFor = (viewer) => async () => {
  if (viewer?.url) {
    return {
      url: viewer.url,
      isDirect: true,
      fileName: viewer.file_name,
      contentType: viewer.content_type,
    };
  }
  if (viewer?.fallback_stream_url) {
    return {
      url: toApiAbsoluteUrl(viewer.fallback_stream_url),
      isDirect: false,
      withCredentials: false,
      fileName: viewer.file_name,
      contentType: viewer.content_type,
    };
  }
  throw new Error(
    viewer?.preparing
      ? "This document is still being prepared for viewing. Try again in a minute."
      : "This document could not be opened.",
  );
};
